<template lang="pug">
  div(:class="$style.headerCards")
    CategoryCard(
      title="Déménagement"
      :link-path="getUrlByHostVersion('header_card_removals')"
      image-peeks-out
      animate-from="bottom"
      @cardClick="trackCardClick"
    )
      figure(:class="[$style.largeLoadingPlaceholder, 'flex justify-center items-center']")
        img(
          src="~/assets/img/homepage/removals-fr.webp"
          srcset="~/assets/img/homepage/removals-fr_2x.webp 2x"
          alt="Déménagement"
          style="--image-width: 420px; --image-height: 370px;"
        )
    CategoryCard(
      title="<span class='hidden md:inline'>Déménagement</span>&nbsp;<span>Europe</span>"
      :link-path="getAbsoluteUrl('publier-annonce/demenagement')"
      image-peeks-out
      animate-from="bottom"
      @cardClick="trackCardClick"
    )
      figure(:class="[$style.largeLoadingPlaceholder, 'flex justify-center items-center']")
        img(
          src="~/assets/img/homepage/international-moves-fr.webp"
          srcset="~/assets/img/homepage/international-moves-fr_2x.webp 2x"
          alt="Déménagement Europe"
          style="--image-width: 420px; --image-height: 370px;"
        )
    CategoryCard(
      title="Meubles"
      :link-path="getUrlByHostVersion('header_card_furniture')"
      @cardClick="trackCardClick"
    )
      figure(:class="[$style.smallLoadingPlaceholder, 'flex justify-center items-center']")
        img(
          src="~/assets/img/homepage/furniture-fr.webp"
          srcset="~/assets/img/homepage/furniture-fr_2x.webp 2x"
          alt="Meubles"
          style="--image-width: 272px; --image-height: 215px;"
        )
    CategoryCard(
      title="Véhicules"
      :link-path="getAbsoluteUrl('publier-annonce/transport-de-voiture')"
      @cardClick="trackCardClick"
    )
      figure(:class="[$style.smallLoadingPlaceholder, 'flex justify-center items-center']")
        img(
          src="~/assets/img/homepage/cars-fr.webp"
          srcset="~/assets/img/homepage/cars-fr_2x.webp 2x"
          alt="Véhicules"
          style="--image-width: 272px; --image-height: 215px;"
        )
    CategoryCard(
      title="Autres"
      :link-path="getAbsoluteUrl('publier-annonce')"
      @cardClick="trackCardClick"
    )
      figure(:class="[$style.smallLoadingPlaceholder, 'flex justify-center items-center']")
        img(
          src="~/assets/img/homepage/other-fr.webp"
          srcset="~/assets/img/homepage/other-fr_2x.webp 2x"
          alt="Autres"
          style="--image-width: 272px; --image-height: 215px;"
        )
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { getV4Host } from "~/scripts/useful-functions"
import { frConfig } from "~/services/public/FrConfig"

export default defineComponent({
  name: "HeaderCardsFR",
  data() {
    return {
      frConfigUrls: frConfig['v2']
    }
  },
  methods: {
    trackCardClick(title: string) {
      this.$snowplow.trackCategoryCardClick(title)
    },
    getAbsoluteUrl(path: string): string {
      return `${this.$config.public.v4Host.replace("com", this.$i18n.locale)}/${path}`
    },
    getUrlByHostVersion(urlName: keyof typeof frConfig.v2): string {
      const url = this.frConfigUrls[urlName]
      if (url.includes("/fr/")) {
        return this.$config.public.v4Host + url
      } else {
        return getV4Host(this.$config.public.v4Host, "fr") + url
      }
    }
  },
  mounted() {
    if (window?.av?.context?.featureFlags?.fr_prelisting_routing_destination === 'v4') {
      this.frConfigUrls = frConfig['v4']
    }
  }
})
</script>

<style module lang="css">
.headerCards {
  @apply grid gap-ds-md md:gap-ds-ml;
  display: grid;
  grid-auto-rows: min-content;
  grid-template-rows: auto auto; /* Two rows */
  grid-template-columns: repeat(6, 1fr); /* First row with two equal columns */

  /* Explicitly place the first two children in the first row */

  > :nth-child(1) {
    grid-column: 1 / 4;
  }

  > :nth-child(2) {
    grid-column: 4 / 7;
  }

  > :nth-child(3) {
    grid-column: 1 / 3;
  }

  > :nth-child(4) {
    grid-column: 3 / 5;
  }

  > :nth-child(5) {
    grid-column: 5 / 7;
  }

  .largeLoadingPlaceholder {
    aspect-ratio: 42 / 37; /* Fixes layout shift prior to images loading */
  }

  .smallLoadingPlaceholder {
    aspect-ratio: 272 / 215; /* Fixes layout shift prior to images loading */
  }
}
</style>
